import * as axios from 'axios';

export const LOAD_EMPLOYEES = '/employee/load_employees';
export const LOAD_WORKING_HOURS = '/employee/load_working_hours';
export const LOAD_CUSTOM_HOURS = '/employee/load_custom_hours';

export function getEmployees(locationId) {
  return function(dispatch) {
    return axios
      .get(`/my_client/v2/employees.json?location_ids=${locationId}&bookable=true`)
      .then(res => {
        dispatch({ type: LOAD_EMPLOYEES, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getWorkingHours(locationId) {
  return function(dispatch) {
    return axios
      .get(`/my_client/v2/working_hours.json?location_ids=${locationId}`)
      .then(res => {
        dispatch({ type: LOAD_WORKING_HOURS, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getCustomHours(locationId) {
  return function(dispatch) {
    return axios
      .get(`/my_client/one_off_hours.json?location_ids=${locationId}`)
      .then(res => {
        dispatch({ type: LOAD_CUSTOM_HOURS, data: res.data });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}